/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 * Lean row for the member Activity feed --- full snapshot is fetched per-meeting on demand.
 * @export
 * @interface TeamMeetingSummary
 */
export interface TeamMeetingSummary {
  /**
   *
   * @type {string}
   * @memberof TeamMeetingSummary
   */
  teamMemberMeetingId: string;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingSummary
   */
  title?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof TeamMeetingSummary
   */
  meetingDate?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingSummary
   */
  summaryShort?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof TeamMeetingSummary
   */
  createdAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingSummary
   */
  createdBy?: string | null;
}

/**
 * Check if a given object implements the TeamMeetingSummary interface.
 */
export function instanceOfTeamMeetingSummary(
  value: object,
): value is TeamMeetingSummary {
  if (
    !("teamMemberMeetingId" in value) ||
    value["teamMemberMeetingId"] === undefined
  )
    return false;
  return true;
}

export function TeamMeetingSummaryFromJSON(json: any): TeamMeetingSummary {
  return TeamMeetingSummaryFromJSONTyped(json, false);
}

export function TeamMeetingSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TeamMeetingSummary {
  if (json == null) {
    return json;
  }
  return {
    teamMemberMeetingId: json["teamMemberMeetingId"],
    title: json["title"] == null ? undefined : json["title"],
    meetingDate: json["meetingDate"] == null ? undefined : json["meetingDate"],
    summaryShort:
      json["summaryShort"] == null ? undefined : json["summaryShort"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
  };
}

export function TeamMeetingSummaryToJSON(json: any): TeamMeetingSummary {
  return TeamMeetingSummaryToJSONTyped(json, false);
}

export function TeamMeetingSummaryToJSONTyped(
  value?: TeamMeetingSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberMeetingId: value["teamMemberMeetingId"],
    title: value["title"],
    meetingDate: value["meetingDate"],
    summaryShort: value["summaryShort"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
  };
}
